import { logger } from '@user-portal/logger';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from 'store/configureStore';

import { ExperimentationWrapper } from 'services/Eppo';

import App from './App';
import reportWebVitals from './reportWebVitals';

const rootDiv = document.getElementById('root');

if (rootDiv) {
    const root = createRoot(rootDiv);

    root.render(
        <Provider store={store}>
            <ExperimentationWrapper>
                <App />
            </ExperimentationWrapper>
        </Provider>
    );
}

reportWebVitals((metric) => {
    logger.info('Web Vitals', {
        name: metric.name,
        value: metric.value,
    });
});
